import { Search } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const SearchIcon = DeckardIconWrapper({ Icon: Search });
